import React from 'react';
import { Route, Switch } from 'react-router-dom';
import SureveyProvisioning from './index';

export default () => {
  return (
    <Switch>
     <Route
        path={`/survey-provisioning/edit/:templateId`}
        component={SureveyProvisioning}
      />
      <Route path={`/survey-provisioning/create`} component={SureveyProvisioning} />
      <Route path={`/survey-provisioning`} component={SureveyProvisioning} />
    </Switch>
  );
};
